// extracted by mini-css-extract-plugin
module.exports = {"nav-items":"HeaderNav_nav-items__2PjrO","nav-item":"HeaderNav_nav-item__8TNfI"};